import { Box, useMediaQuery, useTheme } from '@mui/material'
import { UserWalletsBalanceItem } from './user-wallets-balance-ite.component'
import { useGetTotalUserWalletBalances } from 'src/hooks/users/use-get-total-user-wallets-balances.hook'

interface IProps {}

export const UserWalletsBallatceList = ({}: IProps) => {
  const { data, isLoading } = useGetTotalUserWalletBalances()

  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '5px',
        width: '100%',
      }}
    >
      <UserWalletsBalanceItem
        balance={data?.totalEthBalance || '0'}
        currency="ETH"
        defaultAddress={'0x4200000000000000000000000000000000000006'}
        isLoading={isLoading}
      />
      <UserWalletsBalanceItem
        balance={data?.totalTraiBalance || '0'}
        currency="$TRAI"
        defaultAddress={'0xdd32659B1e7a6A6B3C6e96Cd8a4c936bCfea0607'}
        isLoading={isLoading}
      />
    </Box>
  )
}
